export interface ServiceOrder {
  id: string;
  referenceNumber: number;
  createdAt: Date;
  updatedAt: Date;
  costumerId: string;
  createdBy: string;
  finished: boolean;
}

export function CreateNewServiceOrder(override?: Partial<ServiceOrder>): ServiceOrder {
  return {
    id: "",
    referenceNumber: 0,
    createdAt: new Date(),
    updatedAt: new Date(),
    costumerId: "",
    createdBy: "",
    finished: false,
    ...override
  };
}
